import { render, staticRenderFns } from "./ContractManage.vue?vue&type=template&id=0c6db974&scoped=true&"
import script from "./ContractManage.vue?vue&type=script&lang=js&"
export * from "./ContractManage.vue?vue&type=script&lang=js&"
import style0 from "./ContractManage.vue?vue&type=style&index=0&id=0c6db974&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6db974",
  null
  
)

export default component.exports